import { TFunction } from 'i18next';

export function formatDate(t: TFunction, unixTime: number) {
  const date = new Date(unixTime * 1000);
  return t('translation:date_ymd', {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate()
  });
}
